export default __webpack_public_path__ + "static/media/icon_header_hope_24_Regular.1859563c.svg";